import { gql } from '@apollo/client';

export const LOGIN = gql`
  mutation Login($data: String!) {
    loginCa(data: $data) {
      token
      status
      message
      user {
        isEmailVerified
        isTemporaryPassword
        firstName
        lastName
        createdAt
        lastLoginAt
        email
        employmentdetail {
          employmentStatus
        }
      }
    }
  }
`;

export const LOGIN_WITH_GOOGLE = gql`
  mutation LoginWithGoogle($accessToken: String!) {
    loginWithGoogle(accessToken: $accessToken) {
      token
      status
      message
      user {
        isEmailVerified
        isTemporaryPassword
        firstName
        lastName
        createdAt
        lastLoginAt
        email
        employmentdetail {
          employmentStatus
        }
      }
    }
  }
`;

export const LOGIN_BY_PHONE = gql`
  mutation LoginByPhone($data: String!) {
    loginByPhoneCa(data: $data) {
      token
      message
      status
      user {
        isEmailVerified
        isTemporaryPassword
        firstName
        lastName
        createdAt
        lastLoginAt
        email
        employmentdetail {
          employmentStatus
        }
      }
    }
  }
`;

export const CREATE_USER_CANADA = gql`
  mutation CreateUserCanada($data: String!) {
    createUserCanada(data: $data) {
      message
      status
      token
      user {
        isEmailVerified
        firstName
        lastName
        createdAt
        lastLoginAt
        email
        employmentdetail {
          employmentStatus
        }
      }
    }
  }
`;

export const CREATE_ACCOUNT_WITH_GOOGLE = gql`
  mutation CreateAccountWithGoogle($accessToken: String!, $referralCode: String) {
    createAccountWithGoogle(accessToken: $accessToken, referralCode: $referralCode) {
      message
      status
      token
      user {
        isEmailVerified
        firstName
        lastName
        createdAt
        lastLoginAt
        email
        employmentdetail {
          employmentStatus
        }
      }
    }
  }
`;

export const GET_OTP_FOR_LOGIN = gql`
  mutation GetOTPforLogin($phone: String!) {
    getOTPforLogin(phone: $phone) {
      message
      status
    }
  }
`;

export const LOGIN_WITH_PHONE_AND_OTP = gql`
  mutation loginWithPhoneAndOTPCa($phone: String!, $otp: String!) {
    loginWithPhoneAndOTPCa(phone: $phone, otp: $otp) {
      token
      message
      status
      user {
        isEmailVerified
        firstName
        lastName
        createdAt
        lastLoginAt
        email
        employmentdetail {
          employmentStatus
        }
      }
    }
  }
`;

export const FORGOT_PASSWORD_BY_EMAIL = gql`
  mutation forgotPassword($email: String!) {
    forgotPassword(email: $email) {
      status
      message
    }
  }
`;

export const FORGOT_PASSWORD_BY_PHONE = gql`
  mutation forgotPasswordByPhone($phone: String!) {
    forgotPasswordByPhone(phone: $phone) {
      status
      message
    }
  }
`;

export const RESET_PASSWORD_BY_EMAIL = gql`
  mutation resetpasswordCa($data: String!) {
    resetPasswordCa(data: $data) {
      status
      message
    }
  }
`;

export const RESET_PASSWORD_BY_PHONE = gql`
  mutation resetPasswordByPhoneCa($data: String!) {
    resetPasswordByPhoneCa(data: $data) {
      status
      message
    }
  }
`;

export const CHANGE_PASSWORD_BY_EMAIL = gql`
  mutation ChangePasswordCa($data: String!) {
    changePasswordCa(data: $data) {
      status
      message
    }
  }
`;

export const ACCEPT_OR_REJECT_TENANT_REQUEST = gql`
  mutation AcceptOrRejectTenantRequest(
    $action: String!
    $tenantId: String!
    $options: TenantInviteOptions
  ) {
    acceptOrRejectTenantRequest(action: $action, tenantId: $tenantId, options: $options) {
      status
      message
      data {
        clientSecret
        name
        email
      }
    }
  }
`;

export const RESEND_EMAIL_OTP = gql`
  mutation resendEmailOtp($email: String!) {
    resendEmailOtp(email: $email, isNew: true, isCanada: true) {
      isNewUser
      message
      phone
      email
      status
    }
  }
`;

export const VERIFY_EMAIL_OTP = gql`
  mutation verifyMobileEmailOtp($email: String!, $otp: String!) {
    verifyMobileEmailOTP(email: $email, otp: $otp) {
      status
      message
    }
  }
`;

export const RESEND_OTP = gql`
  mutation resendOtp4DigitCa($phone: String, $isNew: Boolean) {
    resendOtp4DigitCa(phone: $phone, isNew: $isNew) {
      isNewUser
      message
      phone
      status
    }
  }
`;

export const VERIFY_PHONE = gql`
  mutation VerifyPhoneCa($code: String!, $phone: String!) {
    verifyPhoneCa(code: $code, phone: $phone) {
      message
      sentTo
      status
    }
  }
`;

export const CHECK_COMPLIANCE_CA = gql`
  mutation CheckComplianceCa {
    checkComplianceCa {
      status
      notDone {
        icon
        id
        isCompliant
        message
        name
        slug
        status
      }
      message
      isCompliant
      allButPhoneCompleted
      inProgress {
        icon
        id
        isCompliant
        message
        name
        slug
        status
      }
      completed {
        icon
        id
        isCompliant
        message
        name
        slug
        status
      }
    }
  }
`;

export const UPLOAD_USER_AVATAR = gql`
  mutation UpdateUserAvatar($file: Upload!) {
    updateUserAvatar(file: $file) {
      message
      status
      data {
        imageUrl
      }
    }
  }
`;

export const UPDATE_USER_PROFILE_CA = gql`
  mutation updateUserProfileCa($input: UserCaProfileInput, $institution: institutionInput) {
    updateUserProfileCa(input: $input, institution: $institution) {
      status
      message
      data {
        id
        dob
        firstName
        lastName
        otherName
        email
        imageUrl
        gender
        primaryAddress {
          city
          location
          country
          zipCode
        }
        documents {
          id
          docKey
          documentType
          frontImage
          backImage
          uri
          reason
          issueDate
          status
          docKey
          fileName
          documentId
          description
          meta {
            file_size
            contentType
            docOption
            isOthers
          }
        }
        userRtDetail {
          studentEmail
          nationality
        }
      }
    }
  }
`;

export const ADD_USER_DOC = gql`
  mutation AddUserDocumentCa(
    $name: String!
    $file: Upload
    $isOthers: Boolean
    $docOption: String!
  ) {
    addUserDocumentCa(name: $name, file: $file, isOthers: $isOthers, docOption: $docOption) {
      id
      status
      message
      imageUrl
    }
  }
`;

export const REQUEST_PROFILE_UPDATE = gql`
  mutation RequestProfileUpdate($information: String!, $reason: String!) {
    requestProfileUpdate(information: $information, reason: $reason) {
      message
      status
    }
  }
`;

export const CREATE_LANDLORD_MATCH_CA = gql`
  mutation CreateLandlordMatchCa($propertyId: ID!) {
    createLandlordMatchCa(propertyId: $propertyId) {
      message
      status
    }
  }
`;

export const UPDATE_USER_DOC = gql`
  mutation UpdateUserDocumentCa(
    $updateUserDocumentCaId: String!
    $file: Upload!
    $name: String
    $isOthers: Boolean
    $docOption: String!
  ) {
    updateUserDocumentCa(
      id: $updateUserDocumentCaId
      file: $file
      name: $name
      isOthers: $isOthers
      docOption: $docOption
    ) {
      id
      status
      imageUrl
      message
    }
  }
`;

export const UPLOAD_SELFIE = gql`
  mutation UpdateSelfie($imageStr: String) {
    updateSelfie(imageStr: $imageStr) {
      status
      message
      data {
        selfie
      }
      analysisData
    }
  }
`;

export const REQUEST_CREDIT = gql`
  mutation RequestCredit($file: Upload, $input: RequestCreditInput) {
    requestCredit(file: $file, input: $input) {
      message
      status
      data {
        id
        userId
        propertyId
        loanAmount
        downPayment
        repaymentDuration
        loanStatusId
        moratoriumDuration
        hasFirstAndLastMonthPayment
        currency
        loanStartDate
        interest
        meta
        createdAt
        loanStatus {
          id
          name
        }
        property {
          id
          userId
          landlordId
          propertyAddress
          rentAmount
          leaseStartDate
          hasleaseAgreementDoc
          leaseAgreementDoc
          currency
          meta
          createdAt
          updatedAt
          landlord {
            id
            firstName
            lastName
            email
            phone
          }
        }
        loanSchedules {
          id
          userId
          loanId
          payDate
          dueDate
          amountDue
          createdAt
          isFullyPaid
        }
      }
    }
  }
`;

export const REQUEST_GUARANTEE = gql`
  mutation RequestGuarantee($input: RequestGuaranteeInput, $file: Upload) {
    requestGuarantee(input: $input, file: $file) {
      status
      message
      data {
        id
        userId
        currency
        status
        amount
        propertyId
        monthlyRent
        annualIncome
        guaranteeStartDate
        guaranteeEndDate
        approvedBy
        meta
        createdAt
        updatedAt
      }
    }
  }
`;

export const CREDIT_REQUEST_PREVIEW = gql`
  mutation RequestCreditPreview(
    $rentAmount: Float
    $downPayment: Float
    $repaymentDuration: Int
    $moratoriumDuration: Int
  ) {
    requestCreditPreview(
      rentAmount: $rentAmount
      downPayment: $downPayment
      repaymentDuration: $repaymentDuration
      moratoriumDuration: $moratoriumDuration
    ) {
      status
      message
      data {
        downPayment
        installmentPayable
        tenor
        payfiCredit
        moratoriumDuration
        repaymentStartDate
      }
    }
  }
`;

export const REQUEST_GUARANTEE_PREVIEW = gql`
  mutation RequestGuaranteePreview($rentAmount: Float!, $tenor: Int!, $annualIncome: Float) {
    requestGuaranteePreview(rentAmount: $rentAmount, tenor: $tenor, annualIncome: $annualIncome) {
      status
      message
      data {
        oneTimePayment {
          guaranteeFee
          firstAndlastMonthPayment
          processingFee
          dueToday
          tenor
          interestRate
          totalAmountPayable
          monthlyInstallmentAmount
          outstandingBalance
        }
        installment {
          guaranteeFee
          firstAndlastMonthPayment
          processingFee
          dueToday
          tenor
          interestRate
          totalAmountPayable
          monthlyInstallmentAmount
          outstandingBalance
        }
        paymentPlan {
          oneTimePayment
          installment
        }
      }
    }
  }
`;

export const CONTACT_US_PAYFI_CANADA_V2 = gql`
  mutation ContactUsPayfiCanadaV2($message: String!, $product: String!) {
    contactUsPayfiCanadaV2(message: $message, product: $product) {
      status
      message
    }
  }
`;

export const PAY_DOWN_PAYMENT = gql`
  mutation PayCaLoanDownPayment($loanId: ID!) {
    payCaLoanDownPayment(loanId: $loanId) {
      status
      message
      data {
        paymentLink
        interacId
        interacAmount
        reference
        type
      }
    }
  }
`;

export const PAY_REQUEST_GUARANTEE_PAYMENT = gql`
  mutation PayRentGuarantee($rentGuaranteeId: ID!) {
    payRentGuarantee(rentGuaranteeId: $rentGuaranteeId) {
      status
      message
      data {
        paymentLink
        reference
        interacId
        interacAmount
        type
      }
    }
  }
`;

export const PROCESS_DRAFT_GUARANTEE = gql`
  mutation ProcessDraftGuarantee($rentGuaranteeId: String!, $isInstallment: Boolean!) {
    processDraftGuarantee(rentGuaranteeId: $rentGuaranteeId, isInstallment: $isInstallment) {
      message
      status
    }
  }
`;

export const PAY_INITIAL_DEPOSITE_FOR_APARTMENT = gql`
  mutation PayInitialDepositForApartment($payInitialDepositForApartmentId: String!) {
    payInitialDepositForApartment(id: $payInitialDepositForApartmentId) {
      status
      paymentLink
      interacId
      interacAmount
      type
      reference
      message
      data {
        id
        province
        city
        apartmentType
        monthlyBudget
        meta
        monthlyIncome
        paymentAmount
        additionalInformation
        status
      }
    }
  }
`;

export const PAY_FINAL_DEPOSITE_FOR_APARTMENT = gql`
  mutation PayFinalDepositForApartment($payFinalDepositForApartmentId: String!) {
    payFinalDepositForApartment(id: $payFinalDepositForApartmentId) {
      status
      paymentLink
      interacId
      interacAmount
      type
      reference
      message
      data {
        id
        province
        city
        apartmentType
        monthlyBudget
        meta
        monthlyIncome
        paymentAmount
        additionalInformation
        status
      }
    }
  }
`;

export const SET_SECURITY_QUESTION = gql`
  mutation SetWalletSecurityQuestion($securityQuestion: String!, $securityAnswer: String!) {
    setWalletSecurityQuestion(
      securityQuestion: $securityQuestion
      securityAnswer: $securityAnswer
    ) {
      status
      message
      data {
        id
        walletId
        userId
        balance
        status
        partner
        securityQuestion
        meta
      }
    }
  }
`;

export const GET_CREATE_WALLET = gql`
  mutation GetCreateWalletCa {
    getCreateWalletCa {
      status
      message
      data {
        id
        walletId
        userId
        balance
        status
        partner
        securityQuestion
        meta
        updatedAt
      }
    }
  }
`;

export const WALLETCA_WITH_WITHDRAWAL = gql`
  mutation WalletCaWithdrawal($amount: Float!, $securityAnswer: String!) {
    walletCaWithdrawal(amount: $amount, securityAnswer: $securityAnswer) {
      status
      message
      data {
        id
        walletId
        userId
        balance
        status
        partner
        securityQuestion
        meta
        createdAt
        updatedAt
      }
      redeemLink
    }
  }
`;

export const PAY_REPAYMENT = gql`
  mutation PayCaRepayment($loanScheduleId: ID!) {
    payCaRepayment(loanScheduleId: $loanScheduleId) {
      data {
        paymentLink
        interacId
        interacAmount
        type
        reference
      }
      status
      message
    }
  }
`;

export const PAY_GUARANTEE_REPAYMENT = gql`
  mutation PayGuaranteeRepayment($guaranteeScheduleId: ID!) {
    payGuaranteeRepayment(guaranteeScheduleId: $guaranteeScheduleId) {
      status
      message
      data {
        paymentLink
        interacId
        interacAmount
        type
        type
        reference
      }
    }
  }
`;

export const CHIMONEY_PAYMENT_SUBSCRIPTION = gql`
  subscription chimoneyTransaction($transactionId: String!) {
    chimoneyTransaction(transactionId: $transactionId) {
      userId
      transactionId
      amount
      status
      reference
      message
    }
  }
`;

export const GET_CREATE_REFERRAL_DETAIL = gql`
  mutation GetCreateReferralDetail {
    getCreateReferralDetail {
      data {
        balance
        completedReferrals
        createdAt
        earnings
        id
        meta
        referralCode
        totalReferred
        updatedAt
        userId
      }
      message
      status
    }
  }
`;

export const REQUEST_GUARANTEE_PREAPPROVAL = gql`
  mutation RequestGuaranteePreApproval($input: RequestGuaranteePreApprovalInput, $file: Upload) {
    requestGuaranteePreApproval(input: $input, file: $file) {
      status
      message
      data {
        paymentLink
        interacId
        interacAmount
        type
        reference
      }
      guarantee {
        meta
        amount
      }
    }
  }
`;

export const PRODUCT_NOTIFICATION_REQUEST = gql`
  mutation ProductNotificationRequest($productCode: String!, $isNotified: Boolean!) {
    productNotificationRequest(productCode: $productCode, isNotified: $isNotified) {
      message
      status
    }
  }
`;

export const RESET_SECURITY_QUESTION_UPDATE = gql`
  mutation RequestSecurityQuestionUpdate($data: String!) {
    requestSecurityQuestionUpdate(data: $data) {
      data {
        meta
      }
      message
      status
    }
  }
`;

export const RESET_WALLET_SECURITY_QUESTION = gql`
  mutation ResetWalletSecurityQuestion($data: String!) {
    resetWalletSecurityQuestion(data: $data) {
      data {
        balance
      }
      message
      status
    }
  }
`;

export const RESET_PASSWORD_IN_APP = gql`
  mutation ResetPasswordInAppCa($newPassword: String!, $oldPassword: String!) {
    resetPasswordInAppCa(newPassword: $newPassword, oldPassword: $oldPassword) {
      status
      message
    }
  }
`;

export const RENT_PAYMENT_REQUEST = gql`
  mutation RentPaymentRequest($input: RentPaymentInput, $file: Upload) {
    rentPaymentRequest(input: $input, file: $file) {
      data {
        id
        paymentLink
        interacId
        interacAmount
        reference
        type
      }
      message
      status
    }
  }
`;

export const PAY_RENT_PAYMENT_REQUEST = gql`
  mutation PayRentPaymentRequest($rentPaymentId: String) {
    payRentPaymentRequest(rentPaymentId: $rentPaymentId) {
      data {
        id
        paymentLink
        interacId
        interacAmount
        reference
        type
      }
      message
      status
    }
  }
`;

export const REFERRAL_WALLET_CA_WITHDRAWAL = gql`
  mutation ReferralWalletCaWithdrawal($amount: Float!) {
    referralWalletCaWithdrawal(amount: $amount) {
      message
      status
    }
  }
`;

export const UPDATE_USER_PRODUCT_CA = gql`
  mutation UpdateUserProductCa($product: String!) {
    updateUserProductCa(product: $product) {
      data {
        id
        userRtDetail {
          product
        }
      }
      message
      status
    }
  }
`;

export const CREATE_RENT_GUARANTEE_PRE_APPROVAL_DETAILS = gql`
  mutation CreateRentGuaranteePreApprovalDetails($input: RequestGuaranteePreApprovalInput) {
    createRentGuaranteePreApprovalDetails(input: $input) {
      status
      message
      paymentLink
      interacId
      interacAmount
      type
      reference
      data {
        id
        propertyId
        status
        cities
        province
      }
    }
  }
`;

export const CREATE_RENT_GUARANTEE_DETAILS = gql`
  mutation CreateRentGuaranteeDetails($input: CreateRentGuaranteeInput, $file: Upload) {
    createRentGuaranteeDetails(input: $input, file: $file) {
      data {
        id
        propertyId
      }
      status
      message
    }
  }
`;

export const CREATE_APARTMENT_ONBOARDING_DETAILS = gql`
  mutation CreateApartmentOnboardingDetails($input: ApartmentDetailsOnboarding) {
    createApartmentOnboardingDetails(input: $input) {
      message
      paymentLink
      interacId
      interacAmount
      type
      reference
      status
    }
  }
`;

export const UPDATE_GENERAL_INFORMATION_CA = gql`
  mutation UpdateGeneralInformationCa($input: PersonalInfoInputUpdate) {
    updateGeneralInformationCa(input: $input) {
      message
      status
    }
  }
`;

export const CREATE_TENANT_SHARE_PROFILE = gql`
  mutation CreateTenantShareProfile(
    $shareProfileType: String!
    $landlordEmail: String!
    $documents: [String]
    $landlordFullName: String!
  ) {
    createTenantShareProfile(
      shareProfileType: $shareProfileType
      landlordEmail: $landlordEmail
      documents: $documents
      landlordFullName: $landlordFullName
    ) {
      data
      status
      message
    }
  }
`;

export const CREATE_RENT_DETAILS_ONBOARDING = gql`
  mutation CreateRentDetailsOnboarding($input: OnboardingRentPaymentInput, $file: Upload) {
    createRentDetailsOnboarding(input: $input, file: $file) {
      message
      status
    }
  }
`;

export const CAPTURE_PAD_PRODUCT_DATA = gql`
  mutation CapturePADProductData {
    capturePADProductData {
      message
      status
    }
  }
`;

export const UPDATE_USER_CREDIT_BUILDER_STATUS = gql`
  mutation UpdateUserCreditBuilderStatus($isInterested: Boolean!) {
    updateUserCreditBuilderStatus(isInterested: $isInterested) {
      status
      message
      data {
        userRtDetail {
          creditBuilderStatus
        }
      }
    }
  }
`;

export const CREATE_APARTMENT_DETAIL = gql`
  mutation CreateApartmentDetail($input: ApartmentDetailsInput) {
    createApartmentDetail(input: $input) {
      message
      status
      paymentLink
      interacId
      interacAmount
      reference
      type
      data {
        id
        province
        city
        apartmentType
        monthlyBudget
        meta
        monthlyIncome
        paymentAmount
        additionalInformation
      }
    }
  }
`;

export const CREATE_TANGO_ORDER = gql`
  mutation CreateTangoOrder($email: String!, $data: [OrderRewardInputData]) {
    createTangoOrder(email: $email, data: $data) {
      amount
      date
      email
      error
      points
      referenceId
      rewardName
      utid
    }
  }
`;

export const CREATE_BILL_BENEFICIARY = gql`
  mutation CreateBillBeneficiary($data: PayBillInput) {
    createBillBeneficiary(data: $data) {
      message
      status
      statusCode
    }
  }
`;

export const INITIATE_PAY_BILL = gql`
  mutation InitiatePayBill($data: PayBillInput) {
    initiatePayBill(data: $data) {
      message
      status
      statusCode
    }
  }
`;

export const INITIATE_FUND_USER_WALLET = gql`
  mutation InitiateFundUserWallet($amount: Float!) {
    initiateFundUserWallet(amount: $amount) {
      status
      message
      data {
        paymentLink
        reference
        type
      }
    }
  }
`;

export const EDIT_BILL_BENEFICIARY = gql`
  mutation EditBillBeneficiary($data: updateBeneficiaryInput) {
    editBillBeneficiary(data: $data) {
      statusCode
      status
      message
    }
  }
`;

export const DELETE_BILL_BENEFICIARY = gql`
  mutation DeleteBillBeneficiary($deleteBeneficiaryId: String!) {
    deleteBillBeneficiary(deleteBeneficiaryId: $deleteBeneficiaryId) {
      statusCode
      status
      message
    }
  }
`;

export const RENT_PAYMENT_REALTOR_PROPERTY = gql`
  mutation RentPaymentRealtorProperty($narration: String, $tenantId: ID!) {
    rentPaymentRealtorProperty(narration: $narration, tenantId: $tenantId) {
      message
      status
      data {
        id
        paymentLink
        reference
        interacId
        interacAmount
        type
      }
    }
  }
`;
export const UPDATE_STRIPE_INTENT = gql`
  mutation updateStripeIntent($paymentIntentId: String!, $paymentMethod: String!) {
    updateStripeIntent(paymentIntentId: $paymentIntentId, paymentMethod: $paymentMethod) {
      status
    }
  }
`;

export const TENANT_CANCEL_PAD = gql`
  mutation TenantCancelPAD($tenantId: String!) {
    tenantCancelPAD(tenantId: $tenantId) {
      message
      status
    }
  }
`;

export const TENANT_ACTIVATE_PAD = gql`
  mutation TenantActivatePAD($tenantId: String!) {
    tenantActivatePAD(tenantId: $tenantId) {
      data {
        clientSecret
        email
        name
      }
      message
      status
    }
  }
`;
